var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login-Registration-Success"},[_c('p',{staticClass:"Login-Registration-Success__message"},[_vm._v(" Вы успешно зарегистрировались! ")]),_c('BaseButton',{attrs:{"onClickButton":function () { return this$1.$router.push('/login'); }}},[_vm._v("Войти")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }